import React from 'react';
import {useTranslation} from 'react-i18next';
import {useFormikContext} from 'formik';
import CustomSelect, {BaseOption} from '../../Components/Select/CustomSelect';
import SelectSvgSelector from '../../Components/InputSelect/SelectSvgSelector';

const GenderSelect = () => {
	const {t} = useTranslation();
	const {setFieldValue, values} = useFormikContext<{gender: string}>();

	const genderOptions: BaseOption[] = [
		{label: t('Чоловік'), value: 'M'},
		{label: t('Жінка'), value: 'F'},
	];

	const handleChange = (newValue: BaseOption | null) => {
		if (newValue) {
			setFieldValue('gender', newValue.value);
		}
	};

	return (
		<CustomSelect
			name="gender"
			onChange={handleChange}
			placeholder={t('Стать')}
			options={genderOptions}
			value={genderOptions.find((opt) => opt.value === values.gender) || null}
			icon={<SelectSvgSelector id={'nameIcon'} />}
		/>
	);
};

export default GenderSelect;
